import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../../hooks/useIsMobile';

const G = '#0F5A3A';
const GOLD = '#F5B327';
const IVORY = '#F4F0E6';
const BTN_R = '8px';

const COUNSELOR_IMG = 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=700&auto=format&fit=crop&q=80';
const FAMILY_IMG = 'https://images.pexels.com/photos/8199223/pexels-photo-8199223.jpeg?w=700&auto=format&fit=crop&q=80';

export const AudienceSection = () => {
  const isMobile = useIsMobile();

  return (
    <section style={{ background: IVORY, padding: isMobile ? '48px 0' : '72px 0' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: isMobile ? '0 20px' : '0 40px' }}>
        <motion.div initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} style={{ marginBottom: isMobile ? '24px' : '36px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.14em', color: GOLD, marginBottom: '8px' }}>Who It&apos;s For</div>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: isMobile ? '1.75rem' : 'clamp(1.8rem, 3vw, 2.5rem)', fontWeight: 900, color: G, lineHeight: 1.1, letterSpacing: '-0.02em', margin: 0 }}>
            Built for everyone in the journey.
          </h2>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '16px' }}>
          {[{
            img: COUNSELOR_IMG, label: 'FOR COUNSELORS',
            title: 'Advanced tools for every student in your caseload.',
            desc: 'Track progress, manage outreach, and connect your whole school community to real opportunities — all from one platform.',
            pts: ['Track student progress & engagement','Manage coaching notes and deadlines','Access performance reports and insights'],
            cta: 'Counselor Dashboard', href: '/for-counselors', testId: 'audience-card-counselors', bg: G,
          },{
            img: FAMILY_IMG, label: 'FOR FAMILIES',
            title: "Stay informed. Support your student's journey.",
            desc: 'Get alerts on progress, deadlines, and opportunities. Parent resources that keep every family ready for what\'s next.',
            pts: ["Monitor your student's progress and opportunities",'Receive important alerts and deadline reminders','Resources to guide your family every step of the way'],
            cta: 'For Families', href: '/for-families', testId: 'audience-card-families', bg: '#1a2e24',
          }].map((card) => (
            <motion.div key={card.label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
              style={{ borderRadius: '16px', overflow: 'hidden', background: card.bg, minHeight: isMobile ? '320px' : '380px', position: 'relative', display: 'flex', flexDirection: 'column' }}
              data-testid={card.testId}>
              <div style={{ position: 'absolute', inset: 0 }}><img src={card.img} alt={card.label} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.2 }} /></div>
              <div style={{ position: 'relative', zIndex: 2, padding: isMobile ? '28px 24px' : '36px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.14em', color: GOLD, marginBottom: '12px' }}>{card.label}</div>
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: isMobile ? '1.25rem' : '1.5rem', fontWeight: 900, color: '#fff', lineHeight: 1.2, marginBottom: '10px' }}>{card.title}</h3>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.72)', lineHeight: 1.7, marginBottom: '20px' }}>{card.desc}</p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 24px', flex: 1 }}>
                  {card.pts.map(pt => (
                    <li key={pt} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px', fontSize: '14px', color: 'rgba(255,255,255,0.82)' }}>
                      <CheckCircle2 size={15} color={GOLD} style={{ flexShrink: 0, marginTop: '2px' }} /> {pt}
                    </li>
                  ))}
                </ul>
                <Link to={card.href} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '11px 20px', background: GOLD, color: '#1a1a1a', fontWeight: 700, fontSize: '13px', borderRadius: BTN_R, textDecoration: 'none', alignSelf: 'flex-start' }}>
                  {card.cta} <ArrowRight size={13} />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
